export type AutoDealerNavItem = { resource: string; label: string };

export type AutoDealerReportsNavSection = {
    sectionLabel: string;
    items: AutoDealerNavItem[];
};

/** Reports destinations (Auto Dealers workspace), grouped as requested. */
export const AUTO_DEALER_REPORTS_NAV_SECTIONS: AutoDealerReportsNavSection[] = [
    {
        sectionLabel: 'Vehicle',
        items: [
            { resource: 'dispatchReport', label: 'Dispatch Report' },
            { resource: 'insuranceReport', label: 'Insurance Collection Report' },
            { resource: 'saleAging', label: 'Sale Aging' },
            { resource: 'outstandingAging', label: 'Outstanding Aging' },
            { resource: 'outstandingSummary', label: 'Outstanding Summary' },
            { resource: 'dispatchAging', label: 'Dispatch Aging' },
            { resource: 'receivedReport', label: 'Receive Report' },
            { resource: 'recoveryReport', label: 'Recovery Report' },
            { resource: 'saleReport', label: 'Sale Report' },
            { resource: 'commitmentReport', label: 'Commitment Report' },
            { resource: 'salesServiceReport', label: 'Sales Service' },
            { resource: 'transferReport', label: 'Transfer Report' },
        ],
    },
    {
        sectionLabel: 'Payment',
        items: [
            { resource: 'paymentReport', label: 'Payment Report' },
            { resource: 'papersInHand', label: 'Papers In Hand' },
            { resource: 'stockBalance', label: 'Stock Balance' },
        ],
    },
];

/** Flat list (backwards compatible, convenient in workspace registrations). */
export const AUTO_DEALER_REPORTS_NAV: AutoDealerNavItem[] = AUTO_DEALER_REPORTS_NAV_SECTIONS.flatMap(
    s => s.items
);

